<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "KD6",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
@import "../../assets/hkapp.css";
</style>
